import { StorefrontError } from "src/types/storefront";

export default function generateCartErrorMessage(
  cartId: string,
  errors: StorefrontError[]
): string {
  let result = errors.map((error) => error.message).join(", ");
  return result;
}
